import { IRegion, IUnsafeRouteTree, IRouteTree, IUnsafeRoute, IRoute } from'../../../dip/library/di-hnf/di-hnf.js';
import navigation from'../../../pip/library/pi-navigation/pi-navigation.js';
import f1, { t_key } from'../../../pip/library/pi-f1/pi-f1.js';

/**
 * holds the tree of routes for the state/routing machine
 */
export class ViewRouteTree {
  /**
   * read external format of the state-tree and convert to a consistent internal format
   */
  read(stateTree: IUnsafeRouteTree): IRouteTree {
    return f1.pipe<IUnsafeRouteTree, IRouteTree, IRouteTree, IRouteTree, IRouteTree>(
      [
        (stateTree) => this.__fillRootFields__stateTree(stateTree),
        (stateTree) => this.__upgradeRouteFormat__stateTree(stateTree),
        (stateTree) => this.__downgradeOldRouteFormat__stateTree(stateTree),
        (stateTree) => this.__applyTransformations__stateTree(stateTree)
      ],
      stateTree
    );
  }

  private __fillRootFields__stateTree(stateTree: IUnsafeRouteTree): IRouteTree {
    const _stateTree: IRouteTree = stateTree as IRouteTree;

    _stateTree.uri = _stateTree.uri ?? '';
    _stateTree.resource_uri = _stateTree.resource_uri ?? '';
    _stateTree.state = _stateTree.state ?? navigation.uri.uriToState(_stateTree.uri);
    return _stateTree;
  }

  private __upgradeRouteFormat__stateTree(stateTree: IRouteTree) {
    return f1.traverse(
      this.__upgradeRouteFormat,
      this.__upgradeRouteFormat,
      (node: IUnsafeRoute) => (node.navigation_resources ? 'navigation_resources' : 'routes'),
      () => 'uri',
      stateTree
    ) as IRouteTree;
  }

  private __upgradeRouteFormat(node: IUnsafeRoute) {
    node.routes = node.routes ?? node.navigation_resources;
    return node;
  }

  private __downgradeOldRouteFormat__stateTree(stateTree: IRouteTree) {
    return f1.traverse(
      this.__downgradeOldRouteFormat,
      this.__downgradeOldRouteFormat,
      () => 'routes',
      () => 'uri',
      stateTree
    );
  }

  private __downgradeOldRouteFormat(node: IUnsafeRoute) {
    node.navigation_resources = [] as IUnsafeRoute[];
    return node;
  }

  private __applyTransformations__stateTree(stateTree: IRouteTree) {
    f1.each(
      (fn) => {
        f1.traverse(
          fn,
          fn,
          () => 'routes',
          () => 'uri',
          stateTree
        );
      },
      [
        this.__expandStateRegions__stateRoute,
        this.__establishParent__stateRoute,
        this.__establishParents__stateRoute,
        this.__calculateStateName__stateRoute
      ]
    );

    return stateTree;
  }

  /**
   *
   */
  private __expandStateRegions__stateRoute(stateRoute: IRoute) {
    if (f1.is.string(stateRoute.regions)) {
      // @note this is because of type-overlap; in the next block we convert strings to objects
      stateRoute.regions = [(stateRoute.regions as unknown) as IRegion];
    }

    stateRoute.regions = f1.map((view) => {
      return f1.is.string(view) ? { region: 'main', view } : view;
    }, f1.safe([], stateRoute.regions)) as IRegion[];

    return stateRoute;
  }

  private __establishParent__stateRoute(stateRoute: IRoute, key: t_key, parent: IRoute) {
    if (parent !== stateRoute) {
      stateRoute.parent = parent;
    }

    return stateRoute;
  }

  private __establishParents__stateRoute(stateRoute: IRoute) {
    let up: IRoute | undefined = stateRoute;
    const parents = [];

    do {
      if (up.parent) {
        parents.push(up.parent);
      }

      up = up.parent;
    } while (up);

    stateRoute.parents = f1.reverse(parents);
    return stateRoute;
  }

  /**
   *
   */
  private __calculateStateName__stateRoute(stateRoute: IRoute) {
    stateRoute.state = stateRoute.state ?? navigation.uri.uriToState(stateRoute.uri);
    return stateRoute;
  }
}
